import { IconSorting16 } from '@warp-ds/icons/react/sorting-16';
import { Button } from '@warp-ds/react/components/button';
import type { ApiQueryParams, SortValue } from '@/interfaces';
import displayValues from '@/resources/displayValues.json';

interface SortButtonProps {
    defaultValue: SortValue;
    selectedValue?: SortValue;
    sortOptions?: SortValue[];
    changeSort: (newSortValue?: SortValue) => void;
    triggerFetch?: (queryParam?: ApiQueryParams) => void;
}

export const SortButton = ({ defaultValue, selectedValue, sortOptions, changeSort, triggerFetch }: SortButtonProps) => {
    const onClick = (): void => {
        if (!sortOptions) return;

        const currentIndex = sortOptions.indexOf(selectedValue ?? defaultValue);
        const nextIndex = (currentIndex + 1) % sortOptions.length;
        const nextSortOption = sortOptions[nextIndex];

        if (nextSortOption === defaultValue) {
            changeSort(undefined);
        } else {
            changeSort(nextSortOption);
        }
        if (triggerFetch) triggerFetch();
    };

    return (
        <Button utility small onClick={onClick} className="flex gap-8" data-testid="sortButton">
            <IconSorting16 />
            {displayValues.sorting[selectedValue ?? defaultValue]}
        </Button>
    );
};
